<template>
  <validation-observer ref="simpleRules">
    <b-tabs
      pills
      fill
    >
      <b-tab active>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Genel</span>
        </template>
        <b-card title="Sürdürülebilirlik">
          <b-row>
            <b-col cols="12">
              <title-text />
            </b-col>
            <b-col cols="12">
              <sub-title-text />
            </b-col>
            <b-col cols="12">
              <slogan />
            </b-col>
            <b-col cols="12">
              <page-sub-title-text />
            </b-col>
            <b-col
              cols="12"
            >
              <content-text />
            </b-col>
            <b-col
              cols="12"
            >
              <page-content-text />
            </b-col>
          </b-row>
        </b-card>
       <b-row>
         <b-col cols="12" md="6">
           <image-card />
         </b-col>
         <b-col cols="12" md="6">
           <image-card-page />
         </b-col>
       </b-row>
      </b-tab>
      <b-tab>
        <template #title>
          <feather-icon icon="InfoIcon" />
          <span>Sürdürülebilirlik İçerikleri</span>
        </template>
        <items-card />
      </b-tab>
    </b-tabs>

    <b-button
      variant="primary"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </validation-observer>
</template>

<script>
import {
  BCard, BRow, BCol, BButton, BTabs, BTab,
} from 'bootstrap-vue'

import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import TitleText from '@/views/Admin/Sustainability/elements/TitleText.vue'
import SubTitleText from '@/views/Admin/Sustainability/elements/SubTitleText.vue'
import ContentText from '@/views/Admin/Sustainability/elements/ContentText.vue'
import ImageCard from '@/views/Admin/Sustainability/elements/ImageCard.vue'
import ImageCardPage from '@/views/Admin/Sustainability/elements/ImageCardPage.vue'
import ItemsCard from '@/views/Admin/Sustainability/elements/itemsCard.vue'
import Slogan from "@/views/Admin/Sustainability/elements/Slogan.vue";
import PageSubTitleText from "@/views/Admin/Sustainability/elements/PageSubTitleText.vue";
import PageContentText from "@/views/Admin/Sustainability/elements/PageContentText.vue";

export default {
  name: 'Index',
  components: {
    ItemsCard,
    BTab,
    BTabs,
    ValidationObserver,
    BCard,
    BRow,
    BCol,
    BButton,
    TitleText,
    PageSubTitleText,
    Slogan,
    ContentText,
    SubTitleText,
    ImageCard,
    ImageCardPage,
    PageContentText,
  },
  data() {
    return {
      required,
      imageUrl: this.$store.state.app.baseURL,
      itemsForm: false,
      selectItems: null,

    }
  },
  computed: {
    itemData() {
      return this.$store.getters['sustainability/dataItem']
    },
    saveData() {
      return this.$store.getters['sustainability/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({
          variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: val.message,
        })
      } else if (val.status === false) {
        this.showToast({
          variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: val.message,
        })
      }
      this.getData()
    },
  },
  created() {
    localize('tr')
    this.getData()
  },
  methods: {
    getData() {
      this.$store.dispatch('sustainability/getDataItem')
    },
    submitForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.$store.dispatch('sustainability/saveData', this.itemData)
        } else {
          this.showToast({
            title: 'Uyarı!',
            icon: 'XIcon',
            text: 'Lütfen tüm alanları doldurun.',
            variant: 'danger',
          })
        }
      })
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      }, {
        position: 'bottom-center',
      })
    },
  },
}
</script>
